export default {
  header: {
    review_us: 'Reséñanos en Google',
    upload: 'Subir reseña de Google',
    not_now: 'Ahora no',
  },
  steps: {
    how_it_works: 'Cómo funciona',
    step_1: {
      title: 'Paso',
      description: 'Escribe una reseña sobre {{name}} en Google',
    },
    step_2: {
      title: 'Paso',
      description: 'Sube una captura de tu reseña publicada (ver ejemplo abajo)',
    },
  },
  buttons: {
    upload_screenshot: 'Subir captura',
    leave_google_review: 'Dejar reseña en Google',
    submit_screenshot: 'Enviar captura',
    return: 'Volver',
  },
  enter_name: {
    title: 'Nombre publicado con tu reseña de Google',
    place_holder: 'Introduce el nombre',
  },
  screenshot_uploaded: {
    title: 'Captura subida',
    description: 'Desplázate para ver la captura completa',
  },
  loading: {
    processing: 'Tu reseña publicada está siendo revisada',
  },
  error_messages: {
    upload_failed: 'Error al subir la captura. Por favor, inténtalo de nuevo.',
    review_already_uploaded:
      'Parece que ya subiste una captura de una reseña de Google. Solo puedes recibir la recompensa una vez por reseña 😊',
    name_missing: {
      description: 'Introduce el nombre publicado con tu reseña de Google para que podamos identificar tu información.',
      button: {
        title: 'Aceptar',
      },
    },
  },
};
